import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBrands, GetBrandsApiParameter } from "@insite/client-framework/Services/BrandService";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrands";
import { BrandCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<GetBrandsApiParameter, BrandCollectionModel>;

export const RequestDataFromApiExtended: HandlerType = async props => {
    props.apiResult = await getBrands(props.apiParameter);
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiExtended);
